import React, { useState } from "react";
import {
  TextField,
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import GolfTeamNamesConfig from "./GolfTeamNamesConfig";
import GolfCharactersConfig from "./GolfCharactersConfig";

export default function GolfConfig({
  gameConfig,
  setGameConfig,
  loading = false,
  gameProvider,
}) {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleEntryChange = (entryIndex, value) => {
    const newEntries = [...(gameConfig.entries || Array(8).fill(""))];
    newEntries[entryIndex] = value;
    setGameConfig({
      ...gameConfig,
      entries: newEntries,
    });
  };
  const handleShotChange = (entryIndex, value) => {
    const newShots = [...(gameConfig.shots || Array(4).fill(""))];
    newShots[entryIndex] = value;
    setGameConfig({
      ...gameConfig,
      shots: newShots,
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Golf Configuration
        </Typography>
        <Box sx={{ mb: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="golf tabs"
          >
            <Tab label="Entries" />
            <Tab label="Team Names" />
            <Tab label="Characters" />
            <Tab label="Probability" />
          </Tabs>
        </Box>

        {activeTab === 0 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Entry Configuration
            </Typography>
            <Grid container spacing={3}>
              {Array(8)
                .fill(null)
                .map((_, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={`entry-${index}`}
                  >
                    <TextField
                      fullWidth
                      label={`Entry ${index + 1}`}
                      value={gameConfig.entries?.[index] || ""}
                      onChange={(e) => handleEntryChange(index, e.target.value)}
                      variant="outlined"
                      disabled={loading}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#ffffff",
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#ffffff",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#1976d2",
                          fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}

        {activeTab === 1 && (
          <GolfTeamNamesConfig
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
        {activeTab === 2 && (
          <GolfCharactersConfig
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
        {activeTab === 3 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Probability Configuration
            </Typography>
            <Grid container spacing={3}>
              {Array(4)
                .fill(null)
                .map((_, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={`entry-${index}`}
                  >
                    <TextField
                      fullWidth
                      label={`Shot ${index + 1} Win %`}
                      value={gameConfig.shots?.[index] || ""}
                      onChange={(e) => handleShotChange(index, e.target.value)}
                      variant="outlined"
                      disabled={loading}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#ffffff",
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#ffffff",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#1976d2",
                          fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
